<template>
    <div class="layout " id="section_news">
        <div class="bg">
            <div>
                <h2 class="title pt-5 pb-3">更多關於台灣民間習俗及鬼怪傳說故事
                </h2>

            </div>
            <div class="layout_grid layout_content">
                <div class="" v-for="(news, index) of newsInfo" :key="index">
                    <a :href="'https://www.ftvnews.com.tw/news/detail/' + news.ID" target="_blank">
                        <div class="layout_grid_inner_content">
                            <div class="layout_img_inner">
                                <img class="news" loading="lazy" :src="news.Image" alt="news" />
                            </div>
                            <p class="newsp">{{ news.Title }}</p>
                        </div>
                    </a>
                </div>
            </div>
            <hr>
            <div class="layout_grid_inner">


                <div class="layout_sort">
                    <h4>尋妖誌：島嶼妖怪文化之旅</h4>
                    <div class="layout_book">


                        <a href="https://bit.ly/3aYbCC2" target="blank">
                            <img class="book " src="../assets/book1.png" loading="lazy" />

                        </a>
                        <div class="bookcontent">
                            <p>透過台灣民俗與生活記憶中有關妖怪傳說的記憶，採取行旅與踏查的方式尋找台灣妖怪的足跡，其中規劃十一條走訪妖怪的路線，將口傳或文獻所載的妖怪一一揭露其神祕面相，提供可實際按圖索驥的便利性，並搭配行程中的小旅行，但最後呼籲，島嶼千年靈氣，妖怪法力高強，懇請膽小者勿試！
                            </p>
                            <div class="layout_icon">

                                <a href="https://www.facebook.com/morningstarpublishing" target="blank">
                                    <img src="../assets/晨星出版社.png" alt="晨星出版社">
                                </a>
                                <a href="https://www.facebook.com/TPE.Legend" target="blank">
                                    <img src="../assets/台北異文地方工作室.png" alt="台北異文地方工作室">
                                </a>
                            </div>

                        </div>

                    </div>
                </div>

                <div class="layout_sort">
                    <h4>唯妖論：臺灣神怪本事
                    </h4>
                    <div class="layout_book">
                        <a href="https://www.books.com.tw/products/0010730758" target="blank">
                            <img class="book" src="../assets/book2.png" loading="lazy" /></a>

                        <div class="bookcontent">

                            <p>重新認識臺灣的過程中，最缺乏的一塊就是臺灣的妖怪神異文化。本書考察了49個臺灣妖怪神異，每個妖怪神異都包含：繪師重新賦予他們的圖像＋現代版極短篇故事＋詳盡的文獻與田野資料！讓妖怪神異與現代生活緊密相連。
                            </p>
                            <div class="layout_icon">

                                <a href="https://www.facebook.com/kiwifruitstudio" target="blank">
                                    <img src="../assets/奇異果文創.png" alt="奇異果文創"> </a>
                                <a href="https://www.facebook.com/TPE.Legend" target="blank"> <img
                                        src="../assets/台北異文地方工作室.png" alt="台北異文地方工作室"> </a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

            newsInfo: [],
        }
    },

    mounted() {
        var myHeaders = new Headers();
        myHeaders.append("TokenKey", "z1x2c3v4b5n6m78i9o0pftv8859");
        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };
        fetch("https://ftvapi2.ftvnews.com.tw/API/FtvGetNewsWebV2.aspx?sp=6&Cate=民俗", requestOptions)
            .then(response => response.json())  // Assuming the response is in JSON format
            .then(result => {
                console.log(result);  // Optional: log the result
                this.newsInfo = result.ITEM;   // Set the data
            })
            .catch(error => console.log('error', error));
    },
}
</script>

<style scoped>
.layout {
    background-image: url(../assets/底2.jpg);
}

a {
    width: 100%;
    display: flex;
    justify-content: center;
}

.bg {
    max-width: 1000px;
    margin: auto;
}

picture {
    max-width: 400px;
    min-height: 300px;
    display: block;
    margin: auto;
}

.layout_grid div div:nth-last-child(1) a {
    display: inline;
    padding: 0.3rem;
    border: 1px solid;
}


.layout_grid {
    max-width: 1000px;
}

.layout_grid p {
    max-width: 600px;
}

.layout_content {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 1rem;
    width: 90%
}

.layout_grid_inner {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 2rem;
    padding: 1rem;
}

@media screen and (min-width: 768px) {
    .layout_content {
        grid-template-columns: 1fr 1fr;

    }


    .layout_grid_inner {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 2rem;
        padding: 1rem;
    }
}

@media screen and (min-width: 1024px) {
    .layout_content {
        grid-template-columns: 1fr 1fr 1fr;

    }
}

.container {
    margin: auto;
    overflow-y: hidden;
}

.news {
    height: 180px;
    border-radius: 5px;
    box-shadow: rgba(255, 248, 218, 0.4) 0px 30px 90px;
}

.layout_grid_inner_content :hover {
    filter: drop-shadow(0px 0px 20px rgba(238, 212, 151, 0.7));
    transition: .4s
}

hr {
    border: 2px solid rgb(0, 0, 0);
    opacity: .9;
    align-items: center;
}


.layout_book {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-gap: 1rem;
}

.bookcontent {
    height: 300px;
    text-align: left;
    margin-bottom: 1rem;
}



a {
    color: black !important;
    text-decoration: none !important;
    display: flex !important;
    border: 1px transparent !important;
    transition: 0.3s !important;
    font-weight: 500;
    z-index: 700;
}


.book {
    width: 220px;
    width: 100%;
    height: 230px;
    padding: 0;


}

.layout_icon {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 1rem;
}










h4 {
    font-size: 1.8rem !important;
    font-weight: 500 !important;
}

.newsp {
    font-weight: 400 !important;
    line-height: 2rem;
}

.title {
    width: 90%;
    margin: 0 auto;
    padding: 0
}

.layout_grid {
    margin: 1rem auto;
    width: 80%;
}
</style>
